import { render, staticRenderFns } from "./Register3.vue?vue&type=template&id=73e04a2a&"
import script from "./Register3.vue?vue&type=script&lang=js&"
export * from "./Register3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports